import React, { useEffect, useState } from "react";
import { BsThreeDotsVertical, BsToggle2Off, BsToggle2On } from "react-icons/bs";
import SettingCard from "./SettingCard";
import { useDispatch, useSelector } from "react-redux";
import { MdLock } from "react-icons/md";
import altImage from "assets/altImage.png";
import { getUserDashboard } from "store/services/Authentication";
import { showToast } from "utils/showToast";

import {
  activateList,
  setActiveList,
  setList,
  setListItems,
  setLists,
} from "store/actions/Store/list";
import { handleListRequest } from "store/services/Store/List";
import { useNavigate } from "react-router-dom";
import SharedListDetails from "pages/Store/components/SharedListDetails";
import moment from "moment";
import { DATE_FORMAT } from "constants";

const ListCard = ({
  li,
  props,
  openedSettingsId,
  handleSettingsToggle,
  openSharedListId,
  handleSharedToggle,
}) => {
  const { selectedStore } = useSelector((store) => store.selectedStore);
  const { user } = useSelector((store) => store.userReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activateStatus, setactivateStatus] = useState(li.active);
  const [discountedPrice, setDiscountedPrice] = useState(null);
  useEffect(() => {
    setDiscountedPrice(
      parseFloat(li.totalPrice - parseFloat(li.totalPrice) * 0.1).toFixed(2)
    );
  }, [li.totalPrice]);

  const handleListActivate = async () => {
    const result = await handleListRequest({
      method: "put",
      url: `users/${user.data.id}/lists/${li.list_id}/activate`,
      token: user.accessToken,
      data: {
        store_id: selectedStore.id,
      },
    });
    if (result.success) {
      dispatch(activateList({ list_id: li.list_id, status: !activateStatus }));
      showToast(result.data, "success", true);
      setactivateStatus(!activateStatus);
      const lists = await getUserDashboard({
        store_id: selectedStore.id,
        user_id: user.data.id,
        token: user.accessToken,
      });
      if (lists.data) {
        const sortedLists = lists?.data.lists.sort((a, b) => {
          if (a.isOrderPlaced && !b.isOrderPlaced) return 1;
          if (!a.isOrderPlaced && b.isOrderPlaced) return -1;
          return b.active - a.active;
        });
        const activeList = lists.data.lists.find((aL) => aL.active === true);
        dispatch(setActiveList(activeList));
        dispatch(setList(activeList));
        dispatch(setLists(sortedLists));
        dispatch(setListItems(lists.data.listItems));
      }
    } else {
      showToast(result.message, "error", true);
    }
  };

  return (
    <div
      key={li.list_id}
      style={{
        boxShadow: "0px 0px 6px 0px #CDCACA",
        display: selectedStore?.isWhiteLabel && !li?.owner ? "none" : "",
      }}
      className="bg-[#EBEFFF] gap-2 flex flex-grow flex-col md:flex-row lg:flex-row justify-between  rounded-lg  h-auto  "
    >
      <div
        onClick={() => {
          dispatch(setList(li));
          navigate(`/stores/${selectedStore?.id}/lists/${li?.list_id}/review`);
        }}
        className="relative md:w-2/5 lg:w-2/5"
      >
        <div>
          <div className="p-4 " style={{ position: "relative" }}>
            <img
              className="w-full h-full rounded-lg"
              alt="storeLogo"
              src={selectedStore?.cover || altImage}
              style={{
                objectFit: "cover",
                maxWidth: "100%",
                maxHeight: "190px",
              }}
            />
            <div
              className="h-full rounded-lg"
              style={{
                maxWidth: "100%",
                position: "absolute",
                top: "16px",
                left: "16px",
                right: "16px",
                bottom: "16px",
                height: "auto",
                backgroundColor: li.isOrderPlaced
                  ? "rgba(128, 128, 128, 0.3)"
                  : "",
              }}
            ></div>
          </div>
        </div>
        {li.isOrderPlaced && (
          <div className="absolute top-6 left-7">
            <div className="flex justify-start gap-1 align-center">
              <MdLock size={24} />
              <p
                className={"text-sm align-center  text-gray-700 font-extrabold"}
              >
                {" "}
                Order Submitted
              </p>
            </div>
          </div>
        )}
        {li.lock && !selectedStore?.isWhiteLabel && (
          <div className="absolute top-6 left-7">
            <MdLock size={24} />
          </div>
        )}
      </div>
      <div className="flex flex-col justify-between flex-grow w-full h-full px-4 pb-4 pr-4 cursor-pointer select-none md:py-4 md:pl-2 lg:py-4 lg:pl-2 4xl:py-4 4xl:pl-0 md:w-3/5 lg:w-3/5">
        <main>
          <section className="flex justify-between align-center">
            <b className="text-xs text-gray-600">
              created at: {moment.unix(li.created_at).format(DATE_FORMAT)}
            </b>
            <div className="flex justify-center gap-4 align-center">
              <div className={`${li.isOrderPlaced ? "hidden" : ""}`}>
                {li.active ? (
                  <BsToggle2On
                    size={24}
                    style={{
                      color: selectedStore?.theme.color,
                    }}
                    className="text-3xl "
                  />
                ) : (
                  <BsToggle2Off
                    size={24}
                    onClick={() => handleListActivate(li.active)}
                    className="text-3xl text-gray-500"
                  />
                )}
              </div>
              <div
                className={`relative ${
                  openedSettingsId === li?.list_id
                    ? "bg-gray-300 rounded-lg py-1 px-1"
                    : ""
                }`}
              >
                <BsThreeDotsVertical
                  onClick={() => {
                    handleSettingsToggle(li.list_id);
                  }}
                  size={openedSettingsId === li?.list_id ? 16 : 24}
                />
                {openedSettingsId === li.list_id && (
                  <SettingCard
                    props={props}
                    li={li}
                    handleSettingsToggle={handleSettingsToggle}
                  />
                )}
              </div>
            </div>
          </section>
          <section>
            <h1 className="text-2xl font-bold text-black">
              {li?.list.charAt(0).toUpperCase() + li?.list.slice(1)}
            </h1>
            <div className="mt-2">
              {!li.owner && !selectedStore?.isWhiteLabel ? (
                <SharedListDetails
                  li={li}
                  handleSharedToggle={handleSharedToggle}
                  openSharedListId={openSharedListId}
                  title={"Shared By"}
                  subTitle={"List Shared by"}
                />
              ) : (
                <>
                  {li.owner === true &&
                    li?.sharedUsers?.length > 0 &&
                    !selectedStore?.isWhiteLabel && (
                      <SharedListDetails
                        li={li}
                        handleSharedToggle={handleSharedToggle}
                        openSharedListId={openSharedListId}
                        title={"Shared With"}
                        subTitle={"List Shared with"}
                      />
                    )}
                </>
              )}
            </div>
          </section>
        </main>
        <section>
          <h4>{li.items_count} items</h4>
          <div className="flex justify-between font-bold align-center">
            <p className="">Total Price</p>
            <p>
              £{" "}
              {li.isOrderPlaced
                ? discountedPrice
                : Number(li.totalPrice).toFixed(2)}
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ListCard;
